import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DefaultEditor } from 'angular2-smart-table';

@Component({
  template: `
    <div>{{renderValue}}</div>
  `,
})
export class OfbizCustomLinkEditorComponent extends DefaultEditor implements AfterViewInit {
  renderValue: string;
  constructor() {
    super();
   }



  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.renderValue = this.cell.getValue();
  }

}
